import { render, staticRenderFns } from "./EditMainComponent.vue?vue&type=template&id=093f4fd6&scoped=true&"
import script from "./EditMainComponent.vue?vue&type=script&lang=js&"
export * from "./EditMainComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditMainComponent.vue?vue&type=style&index=0&id=093f4fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f4fd6",
  null
  
)

export default component.exports